import React from "react"
import styled from "styled-components"
import ImageHelper, {
  Container as ImageHelperContainer,
} from "@components/ImageHelper"
import { useInView } from "react-intersection-observer"

const Container = styled.div<{ scale: 1 | 2 }>`
  margin: ${({ scale }) => (scale === 1 ? "10vh 0" : 0)};
`

const ImageWrapper = styled.div`
  ${ImageHelperContainer} {
    justify-content: center;
    display: flex;
    width: 100%;
    height: auto;
  }
`

const ZoomedImage = React.forwardRef((props: any, ref: any) => {
  const { ref: viewRef, inView, entry } = useInView({ threshold: 0.65 })

  React.useEffect(() => {
    if (inView) {
      props.toggleActive()
    }
  }, [inView])

  return (
    <Container scale={props.scale} ref={ref}>
      <div ref={viewRef}>
        <ImageWrapper>
          <ImageHelper src={props.image} />
        </ImageWrapper>
      </div>
    </Container>
  )
})

export default ZoomedImage
